import { useEffect } from 'react';
import { useStore } from '@store/appStore';
import { useI18n } from '@i18n/useI18n';
import DefaultTemplate from '@templates/DefaultTemplate';
import { Wrapper } from '@components/GridCards/Common.styled';
import Redeem from '@components/Redeem';
import QRScanScreen from '@components/SQScan';
import RedeemQR from '@components/RedeenQR';

export const RedeemQRPage = () => {
  const { settings } = useStore();

  const i18n = useI18n();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  async function getData(id) {}

  return (
    <DefaultTemplate>
      <Wrapper>
        <RedeemQR />
      </Wrapper>
    </DefaultTemplate>
  );
};

export default RedeemQRPage;
